import {
    newConsumerRecruitmentFormHeader,
    newConsumerRecruitmentFormTitle,
    newConsumerRecruitmentFormAgeQuestion,
    newConsumerRecruitmentFormAgeQuestionOption1,
    newConsumerRecruitmentFormAgeQuestionOption2,
    newConsumerRecruitmentFormPurposeQuestion,
    newConsumerRecruitmentFormPurposeQuestionOption1,
    newConsumerRecruitmentFormPurposeQuestionOption2,
    newConsumerRecruitmentFormPurposeQuestionOption3,
    newConsumerRecruitmentFormPurposeQuestionOption4,
    newConsumerRecruitmentFormThankYouMessage,
    newConsumerRecruitmentFormSubmitButton,
    newConsumerRecruitmentFormNoThanksButton,
} from './NewConsumerRecruitmentForm.locstring.json';
import loc, { format as stringFormat } from 'owa-localize';
import { observer } from 'mobx-react';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';

import * as React from 'react';
import { getCampaignUserInfo } from '../utils/getCampaignUserInfo';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { logNewConsumerRecruitmentResponse } from '../actions/logNewConsumerRecruitmentResponse';

let styles = require('./NewConsumerRecruitmentForm.scss');

export interface NewConsumerRecruitmentFormProps {
    onExit: () => void;
}

export interface RecruitmentFormState {
    firstName: string;
    userEmail: string;
    ageResponse: string;
    purposeResponse: string;
}

@observer
export default class NewConsumerRecruitmentForm extends React.Component<
    NewConsumerRecruitmentFormProps,
    RecruitmentFormState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            firstName: '',
            userEmail: '',
            ageResponse: '',
            purposeResponse: '',
        };
    }

    componentDidMount() {
        let campaignUserInfo = getCampaignUserInfo();
        this.setState({
            firstName: campaignUserInfo.firstName,
            userEmail: campaignUserInfo.userEmail,
        });
    }
    private onAgeSelection = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        this.setState({
            ageResponse: option.key,
        });
    };

    private onPurposeSelection = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        this.setState({
            purposeResponse: option.key,
        });
    };

    render() {
        return (
            <Dialog
                isOpen={true}
                containerClassName={styles.recruitmentMain}
                type={DialogType.close}
                onDismiss={this.onDismiss}
                isBlocking={true}
                title={
                    <div className={styles.recruitmentHeader}>
                        {loc(newConsumerRecruitmentFormHeader)}
                    </div>
                }
                dialogContentProps={{
                    showCloseButton: true,
                }}>
                <div className={styles.recruitmentTitle}>
                    {loc(newConsumerRecruitmentFormTitle)}
                </div>
                <div className={styles.ageQuestion}>
                    <p>{loc(newConsumerRecruitmentFormAgeQuestion)}</p>
                    <ChoiceGroup
                        className={styles.ageRadioList}
                        options={[
                            {
                                key: 'Yes',
                                text: loc(newConsumerRecruitmentFormAgeQuestionOption1),
                            },
                            {
                                key: 'No',
                                text: loc(newConsumerRecruitmentFormAgeQuestionOption2),
                            },
                        ]}
                        onChange={this.onAgeSelection}
                    />
                </div>
                <div className={styles.purposeQuestion}>
                    <p>{loc(newConsumerRecruitmentFormPurposeQuestion)}</p>
                    <ChoiceGroup
                        className={styles.purposeRadioList}
                        options={[
                            {
                                key: 'Personal',
                                text: loc(newConsumerRecruitmentFormPurposeQuestionOption1),
                            },
                            {
                                key: 'School',
                                text: loc(newConsumerRecruitmentFormPurposeQuestionOption2),
                            },
                            {
                                key: 'Small business',
                                text: loc(newConsumerRecruitmentFormPurposeQuestionOption3),
                            },
                            {
                                key: 'Other',
                                text: loc(newConsumerRecruitmentFormPurposeQuestionOption4),
                            },
                        ]}
                        onChange={this.onPurposeSelection}
                    />
                </div>
                <div>
                    <p>
                        {stringFormat(
                            loc(newConsumerRecruitmentFormThankYouMessage),
                            this.state.userEmail
                        )}
                    </p>
                </div>

                <div className={styles.messageButtonsDiv}>
                    <PrimaryButton
                        disabled={this.isSendDisabled()}
                        className={styles.submitButton}
                        onClick={this.onSubmit}>
                        {loc(newConsumerRecruitmentFormSubmitButton)}
                    </PrimaryButton>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <DefaultButton onClick={this.onCancel} className={styles.noThanksButton}>
                        {loc(newConsumerRecruitmentFormNoThanksButton)}
                    </DefaultButton>
                </div>
                {/* https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/47900
                 since this is english only experiment, will do string changes to accomodate hyperlinks later*/}
                <div className={styles.disclaimerDiv}>
                    <p>
                        By replying, you grant Microsoft permission to contact you in email about
                        scheduling a one-time 45-minute phone interview with the Outlook team. The
                        call will be completely anonymous. We won't record it or ask for any
                        personal information. View the{' '}
                        <a target="_blank" href="https://privacy.microsoft.com/privacystatement">
                            Microsoft Privacy Policy
                        </a>
                        .
                    </p>
                </div>
            </Dialog>
        );
    }

    private isSendDisabled = (): boolean => {
        if (this.state.ageResponse != '' && this.state.purposeResponse != '') {
            return false;
        }

        return true;
    };

    private onSubmit = () => {
        logNewConsumerRecruitmentResponse({
            firstName: this.state.firstName,
            userEmail: this.state.userEmail,
            ageResponse: this.state.ageResponse,
            purposeResponse: this.state.purposeResponse,
        });

        this.props.onExit();
    };

    private onCancel = () => {
        this.props.onExit();
    };

    private onDismiss = () => {
        this.props.onExit();
    };
}
